<template>
  <div
    class="input-list"
    :class="getTypeClasses">
    <label :for="id">
      {{label}}
    </label>
    <div class="input-container">
      <select :id="id" :title="label" v-bind="$attrs" v-on="$listeners">
        <option v-for="option in options" :key="option.key || option.value" :value="option.value">
          {{(option.translation && $t(option.translation)) || option.text}}
        </option>
      </select>
      <icon-base class="icon">
        <icon-arrow-down/>
      </icon-base>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.input-list {
  display: flex;
  &.vertical {
    flex-direction: column;
    label {
      font-size: var(--text--xs);
    }
    select {
      width: 100%;
    }
  }
  &.row {
    flex-direction: column;
    label {
      visibility: hidden;
      height: 0;
    }
    select {
      width: 100%;
    }
  }
}

[class="input-list"] {
  @extend %form-row;
  align-items: baseline;
}

.icon {
  pointer-events: none;
}

</style>

<script>
import { v4 as uuid } from 'uuid'
import IconBase from '@/components/icons/IconBase'
import IconArrowDown from '@/components/icons/IconArrowDown'

export default {
  inheritAttrs: false,
  components: {
    'icon-base': IconBase,
    'icon-arrow-down': IconArrowDown
  },
  props: {
    id: {
      type: String,
      default () {
        return uuid()
      }
    },
    dataListId: {
      type: String,
      default () {
        return uuid()
      }
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    getTypeClasses () {
      switch (this.type) {
        case 'vertical':
          return 'vertical'
        case 'row':
          return 'row'
        default:
          return ''
      }
    }
  }
}
</script>
